import { useCallback, useMemo } from 'react';

import { analytics } from 'external-libs/segment';

type Params = {
  pro_impersonated: boolean;
  email: string;
  pro_uuid: string;
};

export const useEventTracking = (params: Params) => {
  const metaData = useMemo(
    () => ({
      context: { screen: { height: window.screen.height, width: window.screen.width } },
    }),
    []
  );

  const trackEvent = useCallback(
    (eventName: string, additionalParams?: Record<string, string | number>) => {
      analytics.track(eventName, {
        ...params,
        path: window.location.pathname,
        referrer: document.referrer,
        title: document.title,
        ...additionalParams,
      });
    },
    [params]
  );

  const trackPage = useCallback(
    (page: string, additionalParams?: Record<string, string | number>) => {
      analytics.page(
        page,
        {
          ...params,
          path: window.location.pathname,
          referrer: document.referrer,
          title: document.title,
          ...additionalParams,
        },
        metaData
      );
    },
    [params, metaData]
  );

  return { trackEvent, trackPage };
};
